import { useEffect } from 'react';

const useApiDataWithTabVisibility = (fetchData, user) => {

    useEffect(() => {
        const visibilityChangeHandler = () => {
            if (!document.hidden) {
                fetchData();
            }
        };

        fetchData();

        document.addEventListener('visibilitychange', visibilityChangeHandler);

        return () => {
            document.removeEventListener('visibilitychange', visibilityChangeHandler);
        };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return true

};

export default useApiDataWithTabVisibility;
